import { useEffect, useState, useCallback } from "react";

/**
 * Lightweight global dark-mode toggle.
 *
 * - Reads the saved choice from localStorage ("pluto.theme" = "light" | "dark").
 * - Defaults to DARK for new visitors (Iter 45.52, per user request).
 * - Toggles the `.dark` class on <html> so Tailwind's `dark:` variants + the
 *   `.dark` override block in index.css both kick in app-wide.
 */
const STORAGE_KEY = "pluto.theme";

function getInitialTheme() {
  if (typeof window === "undefined") return "dark";
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "dark" || saved === "light") return saved;
  } catch {}
  return "dark";
}

export default function useTheme() {
  const [theme, setThemeState] = useState(getInitialTheme);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    try { localStorage.setItem(STORAGE_KEY, theme); } catch {}
  }, [theme]);

  const toggle = useCallback(() => {
    setThemeState((t) => (t === "dark" ? "light" : "dark"));
  }, []);

  return { theme, isDark: theme === "dark", toggle, setTheme: setThemeState };
}
